import { useEffect, useState } from "react";
import { tabIntervalSchema } from "@proof/core";
import { Button, Control } from "./components";

export function TabStops({
  value,
  onChange,
}: {
  value?: number;
  onChange: (value: number | undefined) => void;
}) {
  const [draft, setDraft] = useState(String(value ?? 36)),
    [error, setError] = useState("");
  useEffect(() => {
    setDraft(String(value ?? 36));
    setError("");
  }, [value]);
  return (
    <details className="tab-stops">
      <summary>Text tab stops</summary>
      <p className="inspector-note">
        Tabs advance to the next interval measured from the start of each line.
        A layer override applies to all its paragraphs. Remove it to use
        imported paragraph settings, or the existing spacing when no settings
        are present.
      </p>
      <Control label="Tab interval (pt)">
        <input
          type="number"
          min="0.01"
          max="14400"
          step="0.01"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
        />
      </Control>
      {error && <p role="alert">{error}</p>}
      <div className="button-row">
        <Button
          onClick={() => {
            const parsed = tabIntervalSchema.safeParse(
              draft.trim() ? Number(draft) : NaN,
            );
            if (!parsed.success) {
              setError("Enter a tab interval between 0.01 and 14400 points.");
              return;
            }
            onChange(parsed.data);
            setError("");
          }}
        >
          Apply tab interval
        </Button>
        <Button
          onClick={() => {
            setDraft(String(value ?? 36));
            setError("");
          }}
        >
          Reset tab draft
        </Button>
        {value !== undefined && (
          <Button onClick={() => onChange(undefined)}>
            Remove tab override
          </Button>
        )}
      </div>
      <p className="inspector-note" role="status">
        {value === undefined
          ? "Using paragraph settings / existing spacing"
          : `Layer interval: ${value} pt`}
      </p>
    </details>
  );
}
